var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseNewIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.77 8.28998L15.71 7.22998L12 10.94L8.28998 7.22998L7.22998 8.28998L10.94 12L7.22998 15.71L8.28998 16.77L12 13.06L15.71 16.77L16.77 15.71L13.06 12L16.77 8.28998Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseNewIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Close_New_Icon.2e6c0cd788fb3b27bd2c316c864e4e8c.svg";